import {formatStoreData} from "./formatData.ts";

declare const dataProduct: any[];
import { create } from 'zustand'



export type Package = {
    nom_du_package: string;
    prix_du_package_par_personne: number;
    transport_inclus_dans_le_prix?: boolean | null;
    id_du_bouton_selecteur_de_package: string;
    quantite_de_package_a_vendre: number;
    nombre_de_package_minimum: number;
    nombre_de_package_maximum: number;
    types_de_billet?: Billet[] | null;
    activer_le_module_transport?: boolean | null;
    liste_des_villes_de_depart?: VilleTransport[] | null;
    package_avec_hebergement?: boolean | null
    categorie_de_chambre: CategorieChambre[];
}
export type VilleTransport = {
    ville_de_depart: string;
    prix_de_la_ville_de_depart: number;
}
export type VilleTransportStock = {
    ville_de_depart: string;
    stock: number;
}

export type Billet = {
    intitule_du_type_de_billet: string;
    prix_du_type_de_billet: number;
}

export type CategorieChambre = {
    intitule: string;
    prix: number
    prix_chambre_double?: number | null;
    prix_chambre_twin?: number | null;
    prix_chambre_single?: number | null;
    stock_chambre_double?: number | null;
    stock_chambre_twin?: number | null;
    stock_chambre_single?: number | null;
    prolongation_de_sejour: ProlongationDeSejour[];
}
export type ProlongationDeSejour = {
    nombre_de_jour: string;
    prix: number
}

export type PackageConfig = {
    package: {
        mode_hospitalite: boolean;
        desactiver_les_billets: boolean;
        packages: Package[];
    };
    gestion_des_dates: {
        plusieurs_dates_possibles: boolean;
        date_unique: string;
        listes_des_dates: string[];
    };
    gestion_du_transport: {
        stock_par_ville_de_depart: VilleTransportStock[];
    };
    gestion_assurances: {
        activer_assurance_rapatriement: boolean
        prix_assurance_rapatriement?: number | null;
        activer_assurance_annulation: boolean;
        prix_en_pourcentage_de_panier_de_l_assurance_annulation?: number | null;
    };
};

type Choices = {
    nbPack?: number
    package?: string | null
    date?: string | null
    billet?: string | null
    transport?: string | null
    chambres: string[]
    categorieChambre?: string | null
    moreDays?: string | null
    assuranceAnnulation: boolean
    assuranceRapatriement: boolean
    noAssurance: boolean
    itemKey?: string | null

}

function b64DecodeUnicode(str: string) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}

const searchParams = new URLSearchParams(window.location.search);
const itemKey = searchParams.get('itemKey');
const editParam = searchParams.get('edit');
const editData = editParam ? JSON.parse(b64DecodeUnicode(editParam)) : null;

const initialChoices: Choices = {
    nbPack: editData?.nbPack ?? 1,
    package: editData?.package ?? null,
    date: editData?.date ?? null,
    transport: editData?.transport ?? "Pas de transport",
    billet: editData?.billet ?? null,
    chambres: editData?.chambres ?? [],
    categorieChambre: editData?.categorieChambre ?? null,
    moreDays: editData?.moreDays ?? null,
    assuranceAnnulation: editData?.assuranceAnnulation ?? false,
    assuranceRapatriement: editData?.assuranceRapatriement ?? false,
    noAssurance: editData?.noAssurance ?? false,
    itemKey: itemKey
}

type State = {
    step: number
    maxStep: number
    choices: Choices
    packageConfig: PackageConfig,
    packageDetail: Package | null
}

type Action = {
    nextStep: () => void
    prevStep: () => void
    setChoice: (key:string, value: any) => void,
    setPackageDetail: (packageDetail: Package | null) => void
}


const useConfigurationStore = create<State & Action>()
((set) => (
    {
        packageConfig: typeof dataProduct !== 'undefined' ? formatStoreData(dataProduct) : {} as PackageConfig,
        step: 1,
        maxStep: 5,
        choices: initialChoices,
        packageDetail: null,
        nextStep: () => set((state) => ({ step: state.step < state.maxStep ? state.step + 1 : state.maxStep })),
        prevStep: () => set((state) => ({ step: state.step > 1 ? state.step - 1 : 1 })),
        setChoice: (key, value) => set((state) => {
            //assuranceAnnulation assuranceRapatriement noAssurance
            const opts = {[key]: value}
            if(key === "noAssurance" && value === true){
                opts.assuranceAnnulation = false
                opts.assuranceRapatriement = false
            }
            if(key === "assuranceAnnulation" && value === true){
                opts.noAssurance = false
            }
            if(key === "assuranceRapatriement" && value === true){
                opts.noAssurance = false
            }
            return { choices: { ...state.choices, ...opts } }
        }),
        setPackageDetail: (packageDetail) => set((_) => ({ packageDetail }))
    }
))

export default useConfigurationStore
